<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle" width="700">
                <c-form labe>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="门店名称" name="center_name"></c-form-item>
                    <c-form-item type="input" label="门店联系人" name="contacts"></c-form-item>
                    <c-form-item type="input" label="门店联系电话" name="phone_number"></c-form-item>
                    <c-form-item type="region" label="门店地址"  province-name="province_id" city-name="city_id" style="width: 400px;" county-name="county_id"></c-form-item>
                    <c-form-item type="input" label="详细地址" name="address"></c-form-item>

                </c-form>
            </m-search>
            <c-table ref="table">
                <c-table-column
                        label="会员昵称"
                        name="name"
                        width="150"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>
								{{data.nick_name}}
							</span>
                        </div>
                    </template>
                </c-table-column>
                <c-table-column
                        label="会员手机号"
                        name="user_manage_mobilephone"
                        width="150"
                ></c-table-column>
                <c-table-column
                        label="门店名称"
                        name="center_name"
                        width="250"
                >
                </c-table-column>
                <c-table-column
                        label="门店联系人"
                        name="contacts"
                        width="150"
                ></c-table-column>
                <c-table-column label="门店联系电话" name="phone_number" width="150">
                </c-table-column>
                <c-table-column label="门店地址" name="region" width="250">
                    <template v-slot="{data}">
                        {{data.province_name}} {{data.city_name}} {{data.county_name}} {{data.address}}
                    </template>
                </c-table-column>
                <c-table-column label="创建时间" name="create_date" width="150">
                </c-table-column>
                <c-table-column label="操作" width="150"  type="button"
                                fixed="right">
                    <template v-slot="row">
                        <c-table-button power="b_service_center_edit" @click="editServiceCenter(row)" >编辑</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <c-dialog ref="serviceCenterDialog" title="门店信息" width="800" @resolve="submitServiceCenter" :cancel-button="true">
                <c-form ref="serviceCenterForm" >
                    <c-form-item type="hidden" label="id" name="id" disabled></c-form-item>
                    <c-form-item type="input" label="门店名称" name="center_name" required></c-form-item>
                    <c-form-item type="input" label="门店联系人" name="contacts" required></c-form-item>
                    <c-form-item type="input" label="门店联系电话" name="phone_number" required> </c-form-item>
                    <c-form-item type="region" label="门店地址"  province-name="province_id" city-name="city_id" style="width: 600px;" county-name="county_id" required></c-form-item>
                    <c-form-item type="input" label="详细地址" name="address" required></c-form-item>
                </c-form>
            </c-dialog>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_service_center',

        data() {
            return {
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/service_center/list',
                    data
                });
            },
            editServiceCenter(row) {
                let id = row.data.id;
                this.request({
                    url: '/service_center/detail',
                    data: {
                        id: id
                    },
                    success: data => {
                        this.$refs.serviceCenterForm.set(data);
                        this.$refs.serviceCenterDialog.open();
                    }
                });
            },
            submitServiceCenter(stop){
                stop();
                this.$refs.serviceCenterForm.submit({
                    rule: {
                        center_name: '请填写门店名称',
                        contacts: '请填写门店联系人',
                        phone_number: '请填写门店联系电话',
                        province_id: '请选择门店地址',
                        city_id: '请选择门店地址',
                        county_id: '请选择门店地址',
                        address: '请填写门店地址'
                    },
                    url: '/service_center/update',
                    success: () => {
                        this.$message({
                            text: '修改成功'
                        });
                        this.$refs.serviceCenterDialog.close();
                        this.$refs.table.update();
                    }
                });
            }
        }
    }
</script>